module.exports = new __parcel__URL__("battlepass_background_image.7dbc4bff.png").toString();